import { useIntl } from 'react-intl';

import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

const useIsNpsFlagEnabled = () => {
  const { isEmployee, user } = useUser();

  const intl = useIntl();

  const { data: featureFlags } = useFeatureFlags(
    ['merchant_nps'],
    {
      is_employee: isEmployee,
      user_id: user?.id || '',
      user_email: user?.email || '',
      user_country: user?.country || '',
      user_locale: intl.locale,
    },
    {
      enabled: !!user,
    },
  );

  return featureFlags?.merchant_nps === 'true';
};

export default useIsNpsFlagEnabled;
